export const studyTranslations = {
  fr: {
    title: "Étude",
    navigation: {
      dashboard: "Tableau de bord",
      back: "Retour"
    },
    tabs: {
      qcm: "QCM",
      clinicalCases: "Cas cliniques",
      quizAI: "Quiz IA"
    },
    specialties: {
      cardiologie: "Cardiologie",
      pneumologie: "Pneumologie",
      nephrologie: "Néphrologie",
      neurologie: "Neurologie",
      endocrinologie: "Endocrinologie",
      gastroenterologie: "Gastro-entérologie",
      infectiologie: "Infectiologie",
      urgences: "Médecine d'urgence",
      pediatrie: "Pédiatrie",
      gynecologie: "Gynécologie",
      psychiatrie: "Psychiatrie",
      dermatologie: "Dermatologie",
      ophtalmologie: "Ophtalmologie",
      orthopedie: "Orthopédie",
      oncologie: "Oncologie",
      medecine_generale: "Médecine générale"
    },
    difficulties: {
      easy: 'Facile',
      medium: 'Moyen',
      hard: 'Difficile',
      expert: 'Expert'
    },
    userTypes: {
      student: "Étudiant",
      intern: "Interne",
      resident: "Résident",
      doctor: "Médecin",
      nurse: "Infirmier(ère)",
      paramedic: "Paramédical",
      other: "Autre"
    },
    configuration: {
      title: "Configuration du QCM",
      description: "Personnalisez votre session d'étude selon vos besoins",
      specialty: "Spécialité",
      selectSpecialty: "Choisissez une spécialité...",
      difficulty: "Difficulté",
      questions: "Questions",
      minutes: "Minutes",
      aiGenerated: "Générées par IA",
      generateQuestions: "Générer les questions",
      questionsGenerated: "{{count}} questions générées avec succès",
      caseGenerated: "Cas clinique généré avec succès"
    },
    profile: {
      title: "Votre profil",
      description: "Les questions seront adaptées à votre profil:"
    },
    loading: {
      generating: "Génération en cours...",
      pleaseWait: "Veuillez patienter",
      seconds: "secondes"
    },
    session: {
      score: "Score",
      complete: "Session terminée !",
      resultsDescription: "Voici vos résultats pour cette session",
      correctAnswers: "{{score}}/{{total}} bonnes réponses",
      feedback: {
        excellent: "Excellent travail ! Vous maîtrisez parfaitement ce sujet.",
        good: "Bon travail ! Continuez ainsi.",
        average: "Résultat correct, vous pouvez encore vous améliorer.",
        needsImprovement: "N'abandonnez pas, la pratique rend parfait !"
      },
      totalTime: "Temps total",
      timePerQuestion: "Par question",
      restart: "Recommencer",
      replaySame: "Rejouer",
      backToDashboard: "Retour au tableau de bord",
      questionProgress: "Question {{current}} sur {{total}}",
      submitAnswer: "Valider la réponse",
      correctAnswer: "Bonne réponse !",
      incorrectAnswer: "Mauvaise réponse",
      explanation: "Explication",
      nextQuestion: "Question suivante",
      viewResults: "Voir les résultats",
      completedWithXP: "Session terminée ! +{{xp}} XP gagnés",
      xpEarned: "XP gagnés",
      historyUpdated: "Historique mis à jour avec le nouveau score",
      newEntryCreated: "Nouvelle entrée créée dans l'historique",
      questionRecap: "Récapitulatif question par question"
    },
    celebration: {
      title: "Bravo !",
      quizSubtitle: "Vous avez obtenu {{percentage}}% au QCM",
      caseSubtitle: "Vous avez brillé sur « {{title}} »"
    },
    clinicalCases: {
      title: "Cas cliniques",
      description: "Entraînez-vous avec des cas cliniques réalistes",
      profileDescription: "Les cas seront adaptés à votre profil:",
      steps: "Étapes",
      realistic: "Réaliste",
      stepProgress: "Étape {{current}} sur {{total}}",
      validateDecision: "Valider la décision",
      excellentDecision: "Excellente décision !",
      medicalFeedback: "Analyse médicale",
      nextStep: "Étape suivante",
      finishCase: "Terminer le cas",
      completed: "Cas clinique terminé ! +{{xp}} XP gagnés",
      generateCase: "Générer un cas clinique",
      loadingCase: "Génération du cas clinique...",
      caseTitle: "Cas clinique",
      patientInfo: "Informations du patient",
      symptoms: "Symptômes",
      examination: "Examen clinique",
      results: "Résultats d'examens",
      question: "Question",
      submitDiagnosis: "Valider le diagnostic",
      correctDiagnosis: "Diagnostic correct !",
      incorrectDiagnosis: "Diagnostic incorrect",
      explanation: "Explication",
      generateNewCase: "Nouveau cas"
    },
    aiQuiz: {
      title: "Quiz IA personnalisé",
      description: "Créez un quiz adapté à vos besoins spécifiques",
      prompt: "Décrivez le sujet ou les points que vous souhaitez réviser...",
      promptPlaceholder: "Ex: Révision des arythmies cardiaques pour un étudiant en 4ème année",
      generateQuiz: "Générer le quiz",
      generating: "Génération en cours...",
      startQuiz: "Commencer le quiz",
      questionsGenerated: "{{count}} questions générées",
      customTopic: "Sujet personnalisé"
    },
    errors: {
      generationFailed: "Échec de la génération. Veuillez réessayer.",
      generationError: "Erreur lors de la génération. Veuillez réessayer.",
      caseGenerationError: "Erreur lors de la génération du cas clinique. Veuillez réessayer.",
      sessionSaveError: "Erreur lors de la sauvegarde de la session.",
      loadingFailed: "Erreur lors du chargement",
      noQuestions: "Aucune question générée",
      sessionError: "Erreur de session",
      sessionNotFound: "Session QCM introuvable",
      noQuestionsFound: "Aucune question trouvée dans cette session",
      cannotLoadSession: "Impossible de charger cette session",
      invalidSessionData: "Données de session invalides",
      loadSessionError: "Erreur lors du chargement de la session",
      caseLoadedFromChat: "Cas clinique chargé depuis la conversation",
      qcmLoadedFromChat: "QCM chargé depuis la conversation",
      contentLoadError: "Erreur lors du chargement du contenu généré",
      cleanupError: "Erreur lors du nettoyage des sessions temporaires",
      checkSessionError: "Erreur lors de la vérification des sessions temporaires",
      deleteSessionError: "Erreur lors de la suppression de la session"
    },
    resume: {
      title: "Reprendre une session",
      description: "Vous avez une session en cours",
      continue: "Continuer",
      restart: "Recommencer"
    },
    quizIA: {
      configure: 'Configuration du Quiz IA',
      subtitle: 'Créez des QCM personnalisés basés sur vos besoins d\'étude',
      topicLabel: 'Sujet d\'étude',
      topicPlaceholder: 'Ex: Cardiologie, Neurologie, Pneumologie...',
      difficultyLabel: 'Niveau de difficulté',
      questionCountLabel: 'Nombre de questions',
      questionOptions: {
        3: '3 questions',
        5: '5 questions', 
        10: '10 questions',
        15: '15 questions'
      },
      generating: 'Génération du quiz...',
      startQuiz: 'Commencer le quiz',
      completed: 'Quiz terminé !',
      correctAnswer: 'Bonne réponse !',
      explanation: 'Explication',
      validateAnswer: 'Valider la réponse',
      nextQuestion: 'Question suivante',
      seeResults: 'Voir les résultats',
      generateButton: 'Générer le quiz',
      achievements: {
        perfect: 'Score parfait !',
        excellence: 'Excellence !',
        veryGood: 'Très bon !',
        fast: 'Rapidité !',
        expert: 'Expert !'
      },
      results: {
        scoreMessage: '{{score}} / {{total}} points',
        successRate: '{{rate}}% de réussite',
        excellent: 'Bravo ! Vous excellez dans ce domaine.',
        veryGood: 'Très bien ! Vous êtes sur la bonne voie.',
        goodEffort: 'Bon effort ! Continuez à vous entraîner.',
        keepGoing: 'Courage ! Chaque quiz vous fait progresser.',
        noErrors: 'Bravo ! Aucune erreur - pas besoin de flashcards.',
        flashcardsCreated: '{{count}} flashcard{{s}} créée{{s}} pour les erreurs',
        createFlashcards: 'Créer des flashcards ?',
        flashcardsDesc: 'Générer des fiches de révision basées sur vos erreurs pour mieux retenir',
        createFlashcardsButton: 'Créer des flashcards',
        newQuiz: 'Nouveau quiz'
      }
    },
    history: {
      title: "Historique",
      description: "Vos dernières sessions d'étude",
      replay: "Rejouer",
      deleted: "Session supprimée avec succès",
      deleteError: "Erreur lors de la suppression",
      empty: {
        qcm: "Aucun QCM terminé récemment",
        clinical: "Aucun cas clinique terminé récemment",
        quiz: "Aucun quiz IA terminé récemment"
      }
    }
  },
  en: {
    title: "Study",
    navigation: {
      dashboard: "Dashboard",
      back: "Back"
    },
    tabs: {
      qcm: "MCQ",
      clinicalCases: "Clinical Cases",
      quizAI: "AI Quiz"
    },
    specialties: {
      cardiologie: "Cardiology",
      pneumologie: "Pulmonology",
      nephrologie: "Nephrology",
      neurologie: "Neurology",
      endocrinologie: "Endocrinology",
      gastroenterologie: "Gastroenterology",
      infectiologie: "Infectious Diseases",
      urgences: "Emergency Medicine",
      pediatrie: "Pediatrics",
      gynecologie: "Gynecology",
      psychiatrie: "Psychiatry",
      dermatologie: "Dermatology",
      ophtalmologie: "Ophthalmology",
      orthopedie: "Orthopedics",
      oncologie: "Oncology",
      medecine_generale: "General Medicine"
    },
    difficulties: {
      easy: 'Easy',
      medium: 'Medium',
      hard: 'Hard',
      expert: 'Expert'
    },
    userTypes: {
      student: "Student",
      intern: "Intern",
      resident: "Resident",
      doctor: "Doctor",
      nurse: "Nurse",
      paramedic: "Paramedic",
      other: "Other"
    },
    configuration: {
      title: "MCQ Configuration",
      description: "Customize your study session according to your needs",
      specialty: "Specialty",
      selectSpecialty: "Choose a specialty...",
      difficulty: "Difficulty",
      questions: "Questions",
      minutes: "Minutes",
      aiGenerated: "AI Generated",
      generateQuestions: "Generate questions",
      questionsGenerated: "{{count}} questions generated successfully",
      caseGenerated: "Clinical case generated successfully"
    },
    profile: {
      title: "Your profile",
      description: "Questions will be adapted to your profile:"
    },
    loading: {
      generating: "Generating...",
      pleaseWait: "Please wait",
      seconds: "seconds"
    },
    session: {
      score: "Score",
      complete: "Session completed!",
      resultsDescription: "Here are your results for this session",
      correctAnswers: "{{score}}/{{total}} correct answers",
      feedback: {
        excellent: "Excellent work! You perfectly master this topic.",
        good: "Good work! Keep it up.",
        average: "Correct result, you can still improve.",
        needsImprovement: "Don't give up, practice makes perfect!"
      },
      totalTime: "Total time",
      timePerQuestion: "Per question",
      restart: "Restart",
      replaySame: "Replay",
      backToDashboard: "Back to dashboard",
      questionProgress: "Question {{current}} of {{total}}",
      submitAnswer: "Submit answer",
      correctAnswer: "Correct answer!",
      incorrectAnswer: "Wrong answer",
      explanation: "Explanation",
      nextQuestion: "Next question",
      viewResults: "View results",
      completedWithXP: "Session completed! +{{xp}} XP earned",
      xpEarned: "XP earned",
      historyUpdated: "History updated with new score",
      newEntryCreated: "New entry created in history",
      questionRecap: "Question-by-question recap"
    },
    celebration: {
      title: "Well done!",
      quizSubtitle: "You scored {{percentage}}% on the QCM",
      caseSubtitle: "You aced \"{{title}}\""
    },
    clinicalCases: {
      title: "Clinical Cases",
      description: "Practice with realistic clinical cases",
      profileDescription: "Cases will be adapted to your profile:",
      steps: "Steps",
      realistic: "Realistic",
      stepProgress: "Step {{current}} of {{total}}",
      validateDecision: "Validate decision",
      excellentDecision: "Excellent decision!",
      medicalFeedback: "Medical analysis",
      nextStep: "Next step",
      finishCase: "Finish case",
      completed: "Clinical case completed! +{{xp}} XP earned",
      generateCase: "Generate clinical case",
      loadingCase: "Generating clinical case...",
      caseTitle: "Clinical Case",
      patientInfo: "Patient Information",
      symptoms: "Symptoms",
      examination: "Clinical Examination",
      results: "Test Results",
      question: "Question",
      submitDiagnosis: "Submit diagnosis",
      correctDiagnosis: "Correct diagnosis!",
      incorrectDiagnosis: "Incorrect diagnosis",
      explanation: "Explanation",
      generateNewCase: "New case"
    },
    aiQuiz: {
      title: "Personalized AI Quiz",
      description: "Create a quiz adapted to your specific needs",
      prompt: "Describe the topic or points you want to review...",
      promptPlaceholder: "Ex: Review of cardiac arrhythmias for a 4th year student",
      generateQuiz: "Generate quiz",
      generating: "Generating...",
      startQuiz: "Start quiz",
      questionsGenerated: "{{count}} questions generated",
      customTopic: "Custom topic"
    },
    errors: {
      generationFailed: "Generation failed. Please try again.",
      generationError: "Generation error. Please try again.",
      caseGenerationError: "Error generating clinical case. Please try again.",
      sessionSaveError: "Error saving session.",
      loadingFailed: "Loading error",
      noQuestions: "No questions generated",
      sessionError: "Session error",
      sessionNotFound: "MCQ session not found",
      noQuestionsFound: "No questions found in this session",
      cannotLoadSession: "Unable to load this session",
      invalidSessionData: "Invalid session data",
      loadSessionError: "Error loading session",
      caseLoadedFromChat: "Clinical case loaded from conversation",
      qcmLoadedFromChat: "MCQ loaded from conversation",
      contentLoadError: "Error loading generated content",
      cleanupError: "Error cleaning up temporary sessions",
      checkSessionError: "Error checking temporary sessions",
      deleteSessionError: "Error deleting session"
    },
    resume: {
      title: "Resume session",
      description: "You have a session in progress",
      continue: "Continue",
      restart: "Restart"
    },
    quizIA: {
      configure: 'AI Quiz Configuration',
      subtitle: 'Create personalized MCQs based on your study needs',
      topicLabel: 'Study topic',
      topicPlaceholder: 'Ex: Cardiology, Neurology, Pneumology...',
      difficultyLabel: 'Difficulty level',
      questionCountLabel: 'Number of questions',
      questionOptions: {
        3: '3 questions',
        5: '5 questions',
        10: '10 questions', 
        15: '15 questions'
      },
      generating: 'Generating quiz...',
      startQuiz: 'Start quiz',
      completed: 'Quiz completed!',
      correctAnswer: 'Correct answer!',
      explanation: 'Explanation',
      validateAnswer: 'Validate answer',
      nextQuestion: 'Next question',
      seeResults: 'See results',
      generateButton: 'Generate quiz',
      achievements: {
        perfect: 'Perfect score!',
        excellence: 'Excellence!',
        veryGood: 'Very good!',
        fast: 'Speed!',
        expert: 'Expert!'
      },
      results: {
        scoreMessage: '{{score}} / {{total}} points',
        successRate: '{{rate}}% success rate',
        excellent: 'Great! You excel in this area.',
        veryGood: 'Very good! You\'re on the right track.',
        goodEffort: 'Good effort! Keep practicing.',
        keepGoing: 'Courage! Each quiz helps you progress.',
        noErrors: 'Great! No errors - no need for flashcards.',
        flashcardsCreated: '{{count}} flashcard{{s}} created for errors',
        createFlashcards: 'Create flashcards?',
        flashcardsDesc: 'Generate review cards based on your errors for better retention',
        createFlashcardsButton: 'Create flashcards',
        newQuiz: 'New quiz'
      }
    },
    history: {
      title: "History",
      description: "Your recent study sessions",
      replay: "Replay",
      deleted: "Session deleted successfully",
      deleteError: "Error deleting session",
      empty: {
        qcm: "No recent QCM completed",
        clinical: "No recent clinical cases completed",
        quiz: "No recent AI quiz completed"
      }
    }
  },
  es: {
    title: "Estudio",
    navigation: {
      dashboard: "Panel de control",
      back: "Volver"
    },
    tabs: {
      qcm: "Preguntas múltiples",
      clinicalCases: "Casos clínicos",
      quizAI: "Quiz IA"
    },
    specialties: {
      cardiologie: "Cardiología",
      pneumologie: "Neumología",
      nephrologie: "Nefrología",
      neurologie: "Neurología",
      endocrinologie: "Endocrinología",
      gastroenterologie: "Gastroenterología",
      infectiologie: "Enfermedades infecciosas",
      urgences: "Medicina de urgencias",
      pediatrie: "Pediatría",
      gynecologie: "Ginecología",
      psychiatrie: "Psiquiatría",
      dermatologie: "Dermatología",
      ophtalmologie: "Oftalmología",
      orthopedie: "Ortopedia",
      oncologie: "Oncología",
      medecine_generale: "Medicina general"
    },
    difficulties: {
      easy: 'Fácil',
      medium: 'Medio',
      hard: 'Difícil',
      expert: 'Experto'
    },
    userTypes: {
      student: "Estudiante",
      intern: "Interno",
      resident: "Residente",
      doctor: "Médico",
      nurse: "Enfermero(a)",
      paramedic: "Paramédico",
      other: "Otro"
    },
    configuration: {
      title: "Configuración de preguntas múltiples",
      description: "Personaliza tu sesión de estudio según tus necesidades",
      specialty: "Especialidad",
      selectSpecialty: "Elige una especialidad...",
      difficulty: "Dificultad",
      questions: "Preguntas",
      minutes: "Minutos",
      aiGenerated: "Generadas por IA",
      generateQuestions: "Generar preguntas",
      questionsGenerated: "{{count}} preguntas generadas con éxito",
      caseGenerated: "Caso clínico generado con éxito"
    },
    profile: {
      title: "Tu perfil",
      description: "Las preguntas se adaptarán a tu perfil:"
    },
    loading: {
      generating: "Generando...",
      pleaseWait: "Por favor espere",
      seconds: "segundos"
    },
    session: {
      score: "Puntuación",
      complete: "¡Sesión completada!",
      resultsDescription: "Aquí están tus resultados para esta sesión",
      correctAnswers: "{{score}}/{{total}} respuestas correctas",
      feedback: {
        excellent: "¡Excelente trabajo! Dominas perfectamente este tema.",
        good: "¡Buen trabajo! Continúa así.",
        average: "Resultado correcto, aún puedes mejorar.",
        needsImprovement: "¡No te rindas, la práctica hace al maestro!"
      },
      totalTime: "Tiempo total",
      timePerQuestion: "Por pregunta",
      restart: "Reiniciar",
      replaySame: "Repetir",
      backToDashboard: "Volver al panel",
      questionProgress: "Pregunta {{current}} de {{total}}",
      submitAnswer: "Enviar respuesta",
      correctAnswer: "¡Respuesta correcta!",
      incorrectAnswer: "Respuesta incorrecta",
      explanation: "Explicación",
      nextQuestion: "Siguiente pregunta",
      viewResults: "Ver resultados",
      completedWithXP: "¡Sesión completada! +{{xp}} XP ganados",
      xpEarned: "XP ganados",
      historyUpdated: "Historial actualizado con nueva puntuación",
      newEntryCreated: "Nueva entrada creada en el historial",
      questionRecap: "Resumen pregunta por pregunta"
    },
    celebration: {
      title: "¡Bravo!",
      quizSubtitle: "Obtuviste {{percentage}}% en el QCM",
      caseSubtitle: "Brillaste en \"{{title}}\""
    },
    clinicalCases: {
      title: "Casos clínicos",
      description: "Entrénate con casos clínicos realistas",
      profileDescription: "Los casos se adaptarán a tu perfil:",
      steps: "Pasos",
      realistic: "Realista",
      stepProgress: "Paso {{current}} de {{total}}",
      validateDecision: "Validar decisión",
      excellentDecision: "¡Excelente decisión!",
      medicalFeedback: "Análisis médico",
      nextStep: "Siguiente paso",
      finishCase: "Terminar caso",
      completed: "¡Caso clínico completado! +{{xp}} XP ganados",
      generateCase: "Generar caso clínico",
      loadingCase: "Generando caso clínico...",
      caseTitle: "Caso Clínico",
      patientInfo: "Información del paciente",
      symptoms: "Síntomas",
      examination: "Examen clínico",
      results: "Resultados de exámenes",
      question: "Pregunta",
      submitDiagnosis: "Enviar diagnóstico",
      correctDiagnosis: "¡Diagnóstico correcto!",
      incorrectDiagnosis: "Diagnóstico incorrecto",
      explanation: "Explicación",
      generateNewCase: "Nuevo caso"
    },
    aiQuiz: {
      title: "Quiz IA personalizado",
      description: "Crea un quiz adaptado a tus necesidades específicas",
      prompt: "Describe el tema o puntos que quieres repasar...",
      promptPlaceholder: "Ej: Repaso de arritmias cardíacas para estudiante de 4to año",
      generateQuiz: "Generar quiz",
      generating: "Generando...",
      startQuiz: "Comenzar quiz",
      questionsGenerated: "{{count}} preguntas generadas",
      customTopic: "Tema personalizado"
    },
    errors: {
      generationFailed: "La generación falló. Por favor intenta de nuevo.",
      generationError: "Error de generación. Por favor intenta de nuevo.",
      caseGenerationError: "Error al generar el caso clínico. Por favor intenta de nuevo.",
      sessionSaveError: "Error al guardar la sesión.",
      loadingFailed: "Error de carga",
      noQuestions: "No se generaron preguntas",
      sessionError: "Error de sesión",
      sessionNotFound: "Sesión QCM no encontrada",
      noQuestionsFound: "No se encontraron preguntas en esta sesión",
      cannotLoadSession: "No se pudo cargar esta sesión",
      invalidSessionData: "Datos de sesión inválidos",
      loadSessionError: "Error al cargar la sesión",
      caseLoadedFromChat: "Caso clínico cargado desde la conversación",
      qcmLoadedFromChat: "QCM cargado desde la conversación",
      contentLoadError: "Error al cargar el contenido generado",
      cleanupError: "Error al limpiar sesiones temporales",
      checkSessionError: "Error al verificar sesiones temporales",
      deleteSessionError: "Error al eliminar la sesión"
    },
    resume: {
      title: "Reanudar sesión",
      description: "Tienes una sesión en progreso",
      continue: "Continuar",
      restart: "Reiniciar"
    },
    quizIA: {
      configure: 'Configuración del Quiz IA',
      subtitle: 'Crea MCQs personalizados basados en tus necesidades de estudio',
      topicLabel: 'Tema de estudio',
      topicPlaceholder: 'Ej: Cardiología, Neurología, Neumología...',
      difficultyLabel: 'Nivel de dificultad',
      questionCountLabel: 'Número de preguntas',
      questionOptions: {
        3: '3 preguntas',
        5: '5 preguntas',
        10: '10 preguntas',
        15: '15 preguntas'
      },
      generating: 'Generando quiz...',
      startQuiz: 'Comenzar quiz',
      completed: '¡Quiz completado!',
      correctAnswer: '¡Respuesta correcta!',
      explanation: 'Explicación',
      validateAnswer: 'Validar respuesta',
      nextQuestion: 'Siguiente pregunta',
      seeResults: 'Ver resultados',
      generateButton: 'Generar quiz',
      achievements: {
        perfect: '¡Puntuación perfecta!',
        excellence: '¡Excelencia!',
        veryGood: '¡Muy bueno!',
        fast: '¡Velocidad!',
        expert: '¡Experto!'
      },
      results: {
        scoreMessage: '{{score}} / {{total}} puntos',
        successRate: '{{rate}}% de éxito',
        excellent: '¡Genial! Destacas en esta área.',
        veryGood: '¡Muy bien! Vas por buen camino.',
        goodEffort: '¡Buen esfuerzo! Sigue practicando.',
        keepGoing: '¡Ánimo! Cada quiz te ayuda a progresar.',
        noErrors: '¡Genial! Sin errores - no necesitas flashcards.',
        flashcardsCreated: '{{count}} flashcard{{s}} creada{{s}} para errores',
        createFlashcards: '¿Crear flashcards?',
        flashcardsDesc: 'Generar tarjetas de repaso basadas en tus errores para mejor retención',
        createFlashcardsButton: 'Crear flashcards',
        newQuiz: 'Nuevo quiz'
      }
    },
    history: {
      title: "Historial",
      description: "Tus sesiones de estudio recientes",
      replay: "Repetir",
      deleted: "Sesión eliminada con éxito",
      deleteError: "Error al eliminar la sesión",
      empty: {
        qcm: "Ningún QCM completado recientemente",
        clinical: "Ningún caso clínico completado recientemente",
        quiz: "Ningún quiz IA completado recientemente"
      }
    }
  }
};